module.exports = __webpack_public_path__ + "static/media/settings.f2c80f31.svg";